export default __webpack_public_path__ + "static/media/pantai2.96e0608a.jpeg";